import { useCallback } from 'react';
import { useIntersectionObserver } from './useIntersectionObserver';
import type { RefObject } from 'react';

interface UseScrollToElementWhenNotVisibleOptions {
  ref?: RefObject<HTMLElement | null>;
  root?: Element | null;
  rootMargin?: string;
  threshold?: number | number[];
  enabled?: boolean;
  behavior?: ScrollBehavior;
  block?: ScrollLogicalPosition;
}

export const useScrollToElementWhenNotVisible = (
  options: UseScrollToElementWhenNotVisibleOptions = {}
) => {
  const {
    ref: externalRef,
    root,
    rootMargin,
    threshold,
    enabled,
    behavior = 'smooth',
    block = 'start',
  } = options;

  const { ref, isIntersecting } = useIntersectionObserver({
    ref: externalRef,
    root,
    rootMargin,
    threshold,
    enabled,
  });

  const scrollToElement = useCallback(() => {
    if (!isIntersecting && ref.current) {
      ref.current.scrollIntoView({ behavior, block });
    }
  }, [ref, isIntersecting, behavior, block]);

  return {
    ref,
    scrollToElement,
    isVisible: isIntersecting,
  };
};
